/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
import React, { Component, Fragment } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { Helmet } from 'react-helmet';
import Moment from 'moment';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import PanelPrincipal from './detalle-julia/paquete-detalle-panel-comprar/paquete-detalle-panel-comprar';
import Hoteles from './detalle-julia/paquete-detalle-hoteles/paquete-detalle-hoteles';
import VacacionesAMedida from './paquete-detalle-vacaciones-medida/paquete-detalle-vacaciones-medida';
import Salida from '../paquetes-lista/salida';
import ServiciosIncluidos from './detalle-julia/servicios-incluidos/servicios-incluidos';
import PanelBasico from './panel-basico/panel-basico';
import PanelOperador from './panel-operador/panel-operador';
import NoDisponible from '../layout/error-paquete/no-disponible';
import Transporte from './detalle-julia/transporte/index';
import SeccionConTitulo from './seccion-detalle/seccion-con-titulo';
import commons from '../../commons/commons';
import WarningContainer from './warning-container';

class DetalleJulia extends Component {
  constructor(props) {
    super(props);
    this.formatearPrecio = this.formatearPrecio.bind(this);
    this.armarSalidas = this.armarSalidas.bind(this);
    this.prepararDatosIniciarVenta = this.prepararDatosIniciarVenta.bind(this);
    this.armarDescripcionMeta = this.armarDescripcionMeta.bind(this);
  }

  formatearPrecio(precioNeto, impuestos, impuestoPais, iva, cantPasajeros) {
    let precioRedondeado = 0;
    if (cantPasajeros > 0) {
      precioRedondeado = Math.ceil(
        (precioNeto + impuestos + impuestoPais + iva) / cantPasajeros,
      );
    } else {
      precioRedondeado = Math.ceil(precioNeto + impuestos + impuestoPais + iva);
    }

    return this.formatNumber(precioRedondeado);
  }

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  armarSalidas() {
    const listaSalidas = [];

    if (this.props.salidas) {
      for (let i = 0; i <= this.props.salidas.length - 1; i++) {
        if (this.props.salidaNoVisible !== i) {
          listaSalidas.push(
            <Salida
              proveedorId={this.props.proveedorId}
              distribucion={this.props.distribucion}
              indice={i}
              salidas={this.props.salidas}
              formatearPrecio={this.formatearPrecio}
              cant_pasajeros={
                this.props.paquete.pasajeros !== null
                  ? this.props.paquete.pasajeros.length
                  : this.props.cantidadPasajeros
              }
              key={i}
              hoteles={this.props.salidas[i].hoteles}
              datos={this.props.salidas[i]}
            />,
          );
        }
      }
    }
    return listaSalidas;
  }

  prepararDatosIniciarVenta() {
    let precioRedondeado = Math.ceil(
      this.props.paquete.salidas[0].precios.precioNeto
            + this.props.paquete.salidas[0].precios.impuestos
            + this.props.paquete.salidas[0].precios.iva,
    );
    precioRedondeado = precioRedondeado.toString();
    if (precioRedondeado.length > 4) {
      const punto = '.';
      const position = precioRedondeado.length;
      precioRedondeado = [
        precioRedondeado.slice(0, position - 3),
        punto,
        precioRedondeado.slice(-3, position),
      ].join('');
    }
    return {
      importe: precioRedondeado,
      ventaEstadoId: 1,
      ventaDetalle: this.props.paquete,
      utms: [{ id: 1, descripcion: 'sarasa' }],
    };
  }

  armarDescripcionMeta() {
    const cantPasajeros
            = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    const precio = this.formatearPrecio(
      this.props.paquete.salidas[0].precios.precioNeto,
      this.props.paquete.salidas[0].precios.impuestos,
      this.props.paquete.salidas[0].precios.impuestoPais,
      this.props.paquete.salidas[0].precios.iva,
      cantPasajeros,
    );

    const fechaSalida = Moment(this.props.paquete.salidas[0].fechaSalida).format(
      'DD/MM/YYYY',
    );

    return `ARS ${precio} - Fecha de salida ${fechaSalida}`;
  }

  validarEstadoPaquete(paquete) {
    const now = Moment();
    const desde = Moment(paquete.vigencia.desde);
    const hasta = Moment(paquete.vigencia.hasta);

    if (!!paquete?.disponible && (now <= hasta && desde <= now)) {
      return (
        this.renderizarDetalle()
      );
    }
    return (
      <NoDisponible mensaje='Más opciones para este paquete' />
    );
  }

  renderizarDetalle() {
    const { paquete, cantidadPasajeros, application } = this.props;

    const precioUnitario = commons.precioUnitario(paquete.salidas[0].precios, cantidadPasajeros, application.currency.code);
    const precioUnitarioFormateado = commons.numberFixedToMoney(precioUnitario, 0);

    // eslint-disable
    const observaciones = ReactHtmlParser(this.props.paquete.salidas[0].itinerario.descripcion.replace(/\*/g, '').replace(/OBSERVACIONES/g, '<br/><br/><b>OBSERVACIONES</b><br/>'));
    // eslint-enable
    return (
      <div className='listado-paquetes'>
        <Helmet>
          <meta property='og:title' content={this.props.paquete.nombre} />
          <meta property='og:description' content={this.armarDescripcionMeta()} />
          <meta property='og:image' content={this.props.paquete.imagen} />
          <meta property='og:url' content={isClient ? isClient ? window.location.href : '' : ''} />
          <meta property='og:type' content='website' />
        </Helmet>

        <div className='detalle paquete'>
          <PanelPrincipal
            precioUnitarioFormateado={precioUnitarioFormateado}
            proveedorId={this.props.proveedorId}
            distribucion={this.props.distribucion}
            paquete={this.props.paquete}
            referencia={this.props.referencia}
            formatearPrecio={this.formatearPrecio}
            cantidadPasajeros={this.props.cantidadPasajeros}
          />
          {paquete.salidas[0].precios.mensaje && (
            <WarningContainer>
              {paquete.salidas[0].precios.mensaje}
            </WarningContainer>
          )}
          {this.props.salidas !== undefined ? (
            <div>
              <div id='headingThree' href='#collapseThree' data-toggle='collapse' data-parent='#accordion' className='panel-heading collapsed' role='tab'>
                <h4 className='panel-title'>
                  <a href='#collapseThree' data-toggle='collapse' data-parent='#accordion' style={{ fontWeight: '400!important' }} className='collapsed  accordion-toggle' role='button' aria-expanded='false' aria-controls='collapseThree'>
                    Ver más Salidas
                  </a>
                </h4>
              </div>
              <div id='collapseThree' className='panel-collapse collapse salidas panel paquete' role='tabpanel' aria-labelledby='headingThree'>
                <div className='panel-body'>{this.armarSalidas()}</div>
              </div>
            </div>
          ) : null}
          <div className='container'>
            {this.props.paquete.salidas[0].servicios !== null ? (
              <SeccionConTitulo titulo='Servicios'>
                <ServiciosIncluidos
                  descripcion={this.props.paquete.salidas[0].servicios}
                  iconos={this.props.paquete.salidas[0].tipoServicios}
                />
              </SeccionConTitulo>
            )
              : ''}
            {this.props.paquete.salidas[0].transporte !== null ? (
              <SeccionConTitulo titulo='Transporte'>
                <Transporte
                  origen={this.props.paquete.salidas[0].origen}
                  destino={this.props.paquete.salidas[0].destino}
                  transporte={this.props.paquete.salidas[0].transporte}
                />
              </SeccionConTitulo>
            )
              : ''}
            {this.props.paquete.salidas[0].hoteles !== null ? (
              <SeccionConTitulo titulo='Alojamientos'>
                <Hoteles
                  destinos={this.props.paquete.salidas[0].destinosHoteles}
                  hoteles={this.props.paquete.salidas[0].hoteles}
                />
              </SeccionConTitulo>
            )
              : ''}
            {observaciones !== null ? (
              <SeccionConTitulo titulo='Descripción'>
                <PanelBasico
                  titulo='Notas'
                  contenido={observaciones}
                />
              </SeccionConTitulo>
            )
              : ''}
            <SeccionConTitulo>
              <VacacionesAMedida
                referencia={this.props.referencia}
                proveedorId={this.props.proveedorId}
                destino={this.props.paquete.salidas[0].destinoIata}
                fechaSalida={this.props.paquete.salidas[0].fechaSalida}
                cantidadNoches={this.props.paquete.cantNoches}
              />
            </SeccionConTitulo>
            <SeccionConTitulo>
              <PanelOperador
                datos={this.props.paquete.operadorResponsable}
              />
            </SeccionConTitulo>
          </div>
          <div className='clearfix' />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.renderizarDetalle()}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(DetalleJulia);
